/**
 * ScoreGauge — SVG circular score gauge for SEO scores (0–100).
 * Grade colours: A+ / A → green, B → teal, C → yellow, D → orange, F → red
 */
import React from "react";

const GRADE_COLOR = {
  "A+": "#00ff88",
  A:   "#00ff88",
  B:   "#00cfaa",
  C:   "#f5c518",
  D:   "#ff8c42",
  F:   "#ff4d6d",
};

function gradeFromScore(score) {
  if (score >= 95) return "A+";
  if (score >= 80) return "A";
  if (score >= 65) return "B";
  if (score >= 50) return "C";
  if (score >= 35) return "D";
  return "F";
}

export default function ScoreGauge({ score = 0, size = 120, label = "" }) {
  const r = (size / 2) * 0.78;
  const cx = size / 2;
  const cy = size / 2;
  const circumference = 2 * Math.PI * r;
  const clampedScore = Math.max(0, Math.min(100, score));
  const offset = circumference * (1 - clampedScore / 100);
  const grade = gradeFromScore(clampedScore);
  const color = GRADE_COLOR[grade];

  return (
    <div className="seo-gauge-wrap" style={{ width: size, height: size }}>
      <svg width={size} height={size} style={{ transform: "rotate(-90deg)" }}>
        {/* Track */}
        <circle
          cx={cx} cy={cy} r={r}
          fill="none"
          stroke="rgba(255,255,255,0.07)"
          strokeWidth={size * 0.08}
        />
        {/* Progress */}
        <circle
          cx={cx} cy={cy} r={r}
          fill="none"
          stroke={color}
          strokeWidth={size * 0.08}
          strokeDasharray={circumference}
          strokeDashoffset={offset}
          strokeLinecap="round"
          style={{ transition: "stroke-dashoffset 0.6s ease" }}
        />
      </svg>
      <div className="seo-gauge-center">
        <span className="seo-gauge-score" style={{ color, fontSize: size * 0.22 }}>
          {clampedScore}
        </span>
        <span className="seo-gauge-grade" style={{ color, fontSize: size * 0.16 }}>
          {grade}
        </span>
        {label && (
          <span className="seo-gauge-label" style={{ fontSize: size * 0.1 }}>
            {label}
          </span>
        )}
      </div>
    </div>
  );
}
